/* eslint-disable react-hooks/exhaustive-deps */
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import Table from "../../common/Table";
import Body from "../../components/Body";
import useHeader from "../../hooks/useHeader";
import useJob from "../../hooks/useJob";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getJobs } from "../../stores/JobStore";
import { getPosGroupedByJob } from "../../stores/PoStore";
import { getLocations } from "../../stores/LocationStore";
import { getOrganizations } from "../../stores/OrganizationStore";
import { getPaymentsGroupedByJob } from "../../stores/PaymentStore";
const header = [
  { name: "jobId", title: "Job ID", filter: "Search" },
  { name: "organizationName", title: "Client", filter: "Search" },
  // { name: "location", title: "Location", filter: "Search" },
  { name: "startDate", title: "Start", filter: "DatePicker" },
  { name: "endDate", title: "End", filter: "DatePicker" },
  { name: "balance", title: "Balance", style: { textAlign: "left" } },
];
function UnpaidInvs() {
  const job = useJob();
  const navigate = useNavigate();

  const { data: jobs } = useQuery({
    queryFn: () => getJobs(),
    queryKey: ["jobs"],
  });

  const { data: posGroupedByJob } = useQuery({
    queryFn: () => getPosGroupedByJob(),
    queryKey: ["pos", "groupedByJob"],
  });

  const { data: locationsData } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { data: organizations } = useQuery({
    queryFn: () => getOrganizations(),
    queryKey: ["organizations"],
  });

  const { data: paymentsGroupedByJob } = useQuery({
    queryFn: () => getPaymentsGroupedByJob(),
    queryKey: ["jobPayments", "groupedByJob"],
  });

  const { setHeader } = useHeader();
  const [skip, setSkip] = useState(0);
  const LIMIT = 100;
  const before3Month = moment(
    moment().add(-3, "months").format("DD/MM/YYYY"),
    "DD/MM/YYYY"
  ).valueOf();
  const data = jobs
    ?.filter((jb) => {
      return (
        moment(
          moment(jb.invoiceDate).format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ).valueOf() < before3Month
      );
    })
    // .slice(0, skip + LIMIT)
    .map((jb) => {
      const pos = posGroupedByJob?.[jb._id];
      const po = pos ? pos[pos.length - 1] : undefined;
      const locations = jb?.location?.map((loc) => {
        const found = locationsData?.find((item) => item._id === loc);
        return found;
      });
      return {
        ...jb,
        organizationName: organizations?.find((i) => i._id === jb.organization)
          ?.name,
        location: `${locations
          ?.filter((i) => i)
          ?.map((i) => i.title)
          .join(", ")}`,
        poNo: po?.poNo || " - ",
        payments: paymentsGroupedByJob?.[jb._id],
        startDate: moment(jb.jobStartDate).format("DD/MM/YYYY"),
        endDate: moment(jb.jobEndDate).format("DD/MM/YYYY"),
        balance: `$ ${addPrecision(job.invoiceBalance({ job: jb }))}`,
      };
    })
    .filter((jb) => {
      return job.paymentStatus({ job: jb }) !== "Completed";
    });
  const handleLoadMore = async () => {
    setSkip(skip + LIMIT);
  };
  const [loadingMore, setLoadingMore] = useState(false);
  useEffect(() => {
    setHeader("3 Month Unpaid Invoices");
  }, []);

  const handleView = (data) => {
    const path = job.findPath({ job: data });
    delete data.status;

    navigate(path, { state: { data: cloneDeep(data) } });
  };
  const [model, setModel] = useState({});
  return (
    <div>
      <Body noPadding>
        <Table
          header={header}
          data={data}
          SideButtons={({ inv }) => {
            return (
              <div className="side-button">
                <AppButton
                  onClick={() => handleView(inv)}
                  tooltip="More Details"
                  className="text-primary"
                  leftIcon={<FaEye />}
                />
              </div>
            );
          }}
        />

        <AppModal
          onHide={() => {
            setModel({});
          }}
          {...model}
        />
      </Body>
      {/* {data.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          <AppButton
            onClick={handleLoadMore}
            text="Load more..."
            className="btn-secondary"
            disabled={loadingMore}
          />
        </div>
      )} */}
    </div>
  );
}
export default observer(UnpaidInvs);
